<template>
  <div class="removed-page">
    <van-nav-bar
      title="已下架资源"
      left-arrow fixed
      @click-left="$router.back()"
    />

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="— 没有更多了 —"
        @load="onLoad"
      >
        <van-swipe-cell v-for="item in list" :key="item.id">
          <div class="resource-card">
            <div class="card-cover">
              <img v-if="item.coverUrl" :src="item.coverUrl" alt="" />
              <div v-else class="cover-placeholder">
                <van-icon name="photo-o" size="32" color="#cbd5e1" />
              </div>
              <div class="cover-badge" :class="item.isPaid ? 'is-paid' : 'is-free'">
                {{ item.isPaid ? '¥' + item.price : '免费' }}
              </div>
            </div>
            <div class="card-body">
              <div class="card-title">{{ item.title }}</div>
              <div class="card-desc" v-if="item.description">{{ item.description }}</div>
              <div class="card-footer">
                <van-tag type="default" size="small" plain>已下架</van-tag>
                <span class="card-date">{{ formatDate(item.updatedAt) }}</span>
              </div>
            </div>
          </div>
          <template #right>
            <van-button square color="#10b981" text="上架" @click="onRelist(item)" class="relist-btn" />
          </template>
        </van-swipe-cell>
      </van-list>
    </van-pull-refresh>

    <van-empty
      v-if="!loading && list.length === 0"
      image="search"
      description="暂无已下架资源"
    />
  </div>
</template>

<script>
import { resourceApi } from '../api';

export default {
  data() {
    return {
      list: [], page: 1, size: 10, loading: false, finished: false, refreshing: false
    };
  },
  methods: {
    async onLoad() {
      const user = this.$store.state.user;
      const res = await resourceApi.listByBlogger(user.id, {
        page: this.page, size: this.size, status: 'removed'
      });
      const data = res.data;
      this.list = this.page === 1 ? data.list : [...this.list, ...data.list];
      this.loading = false;
      if (this.list.length >= data.total) this.finished = true;
      this.page++;
    },
    async onRefresh() {
      this.page = 1; this.finished = false; this.list = [];
      await this.onLoad();
      this.refreshing = false;
    },
    async onRelist(item) {
      try {
        await this.$dialog.confirm({ title: '重新上架', message: '确定要重新上架该资源吗？' });
        await resourceApi.relist(item.id);
        this.$toast.success('已重新上架');
        this.onRefresh();
      } catch (e) { /* canceled */ }
    },
    formatDate(d) {
      if (!d) return '';
      const dt = new Date(d);
      return dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0');
    }
  }
};
</script>

<style scoped>
.removed-page { min-height: 100vh; background: #f5f7fa; padding-top: 46px; }
.resource-card {
  display: flex; margin: 12px 16px;
  background: #fff; border-radius: 12px;
  overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.card-cover {
  width: 100px; height: 100px; flex-shrink: 0; position: relative;
  background: #f1f5f9;
}
.card-cover img {
  width: 100%; height: 100%; object-fit: cover;
}
.cover-placeholder {
  width: 100%; height: 100%;
  display: flex; align-items: center; justify-content: center;
}
.cover-badge {
  position: absolute; top: 6px; left: 6px;
  padding: 2px 8px; border-radius: 10px;
  font-size: 12px; font-weight: 600; color: #fff;
}
.cover-badge.is-paid { background: rgba(239,68,68,0.9); }
.cover-badge.is-free { background: rgba(34,197,94,0.9); }
.card-body {
  flex: 1; padding: 10px 12px; display: flex;
  flex-direction: column; justify-content: space-between;
  min-width: 0;
}
.card-title {
  font-size: 15px; font-weight: 600; color: #1f2937;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.card-desc {
  font-size: 12px; color: #9ca3af;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  margin-top: 4px;
}
.card-footer {
  display: flex; align-items: center; justify-content: space-between;
}
.card-date { font-size: 11px; color: #d1d5db; }
.relist-btn {
  height: 100%;
}
</style>
